module.exports = "<div class=c-status-banner ng-if=$ctrl.shouldDisplay()> <div class=grid-x> <div class=\"cell shrink\"> <icon icon=info></icon> </div> <div class=\"cell auto\"> <div class=c-status-banner__phone ng-if=$ctrl.showPhoneBanner()> <h5>Telephone only</h5> <p ng-if=$ctrl.number>Please call us on <strong>{{ $ctrl.number }}</strong> to find out if we have any availability.</p> </div> <div class=c-status-banner__online ng-if=$ctrl.showOnlineBanner()> <h5>Online exclusive</h5> <p>This event is only bookable online.</p> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/statusBanner.html
// module id = 784
// module chunks = 0